export default __webpack_public_path__ + "static/englishExpress-9d7ff88d3ce17752a38f6dc88b401189.svg";